module.exports = __webpack_public_path__ + "img/hexagon.2d95a138.svg";